import {
  Activity,
  ArrowLeftRight,
  Building2,
  Calculator,
  Droplets,
  FileCode2,
  Fingerprint,
  Key,
  Layers,
  LayoutDashboard,
  PlusCircle,
  ScrollText,
  Settings,
  Wallet,
  Zap,
} from "lucide-react";

import type { LucideIcon } from "lucide-react";

// ---------------------------------------------------------------------------
// Shared navigation definitions for devtools apps (devenv, webenv, etc.)
// ---------------------------------------------------------------------------

export interface ViewDef {
  id: string;
  label: string;
  path: string;
  group: string;
  icon: LucideIcon;
}

/** Base group names shared across all devtools apps. */
export const BASE_GROUPS = [
  "Protocol",
  "Trading",
  "Vaults",
  "Identity",
  "Dev Tools",
  "Monitoring",
] as const;

/** The 12 views shared across all devtools apps. */
export const BASE_VIEWS: ViewDef[] = [
  {
    id: "overview",
    label: "Overview",
    path: "/",
    group: "Protocol",
    icon: LayoutDashboard,
  },
  {
    id: "pools",
    label: "Pool Explorer",
    path: "/pools",
    group: "Protocol",
    icon: Droplets,
  },
  {
    id: "swap",
    label: "Swap",
    path: "/swap",
    group: "Trading",
    icon: ArrowLeftRight,
  },
  {
    id: "liquidity",
    label: "Liquidity",
    path: "/liquidity",
    group: "Trading",
    icon: Layers,
  },
  {
    id: "uniswapx",
    label: "UniswapX Orders",
    path: "/uniswapx",
    group: "Trading",
    icon: Zap,
  },
  {
    id: "vaults",
    label: "Vault Explorer",
    path: "/vaults",
    group: "Vaults",
    icon: Building2,
  },
  {
    id: "vault-create",
    label: "Create Vault",
    path: "/vaults/create",
    group: "Vaults",
    icon: PlusCircle,
  },
  {
    id: "fees",
    label: "Fee Inspector",
    path: "/fees",
    group: "Vaults",
    icon: Calculator,
  },
  {
    id: "agents",
    label: "Identity Registry",
    path: "/agents",
    group: "Identity",
    icon: Fingerprint,
  },
  {
    id: "agents-register",
    label: "Register Identity",
    path: "/agents/register",
    group: "Identity",
    icon: PlusCircle,
  },
  {
    id: "chain",
    label: "Chain Controls",
    path: "/chain",
    group: "Dev Tools",
    icon: Settings,
  },
  {
    id: "keys",
    label: "Key Management",
    path: "/keys",
    group: "Dev Tools",
    icon: Key,
  },
  {
    id: "contracts",
    label: "Contracts",
    path: "/contracts",
    group: "Dev Tools",
    icon: FileCode2,
  },
  {
    id: "balances",
    label: "Balances",
    path: "/balances",
    group: "Monitoring",
    icon: Wallet,
  },
  {
    id: "txlog",
    label: "TX Log",
    path: "/txlog",
    group: "Monitoring",
    icon: ScrollText,
  },
  {
    id: "events",
    label: "Event Viewer",
    path: "/events",
    group: "Monitoring",
    icon: Activity,
  },
];
